import { render } from "./WaitConfirmation.vue?vue&type=template&id=1336245d&lang=pug"
import script from "./WaitConfirmation.vue?vue&type=script&lang=js"
export * from "./WaitConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__